import api from '../api';
import infoBoard from '../core/infoboard';
import translate from '../core/tools/translate';
import environment from '../environment';
import { CoreControl } from './CoreControl';
import { VectorType } from './VectorType';

const LayerInfo = (name) => require('../info').get(name);

export class PointOfInterestControl extends CoreControl {
    constructor () {
        super({ name: 'PointOfInterest' });

        this._toggleLabel = this._toggleLabel.bind(this);

        this.resizeIcon = this.resizeIcon.bind(this);
        this.highlight = this.highlight.bind(this);
        this.unselect = this.unselect.bind(this);
    }

    static getInstance () {
        if (!PointOfInterestControl._instance) {
            PointOfInterestControl._instance = new PointOfInterestControl();
        }

        return PointOfInterestControl._instance;
    }

    init () {
        const values = {
            disableSlider: true,
            help: translate(`Help.${this.options.name}`),
            id: 'layer-points',
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            layer: this.getLayer,
            change: this._change,
            name: this.options.name,
            type: 'vector-points',
            purge: this.purge,
            tab () {
                return $('#points-tab-link');
            },
            resize: {
                name: `pinSize${this.options.name}`,
                change: this.resizeIcon,
                type: 'radio'
            },
            checkbox: {}
        };

        if (!this._instance) {
            this._instance = new VectorType(values);
        }

        this._tags = {
            tagName: {
                property: 'Name',
                align: 'east',
                size: 9,
                offsetY: 20,
                offsetX: -2,
                bold: true,
                box: true,
            },
        };

        values.checkbox[translate('Action.ShowTagName')] = {
            name: `tagName`,
            change: this._toggleLabel,
            style: {
                change: (tag) => {
                    this._tags.tagName = tag;
                    this._toggleLabel(this.getControls().checkbox.tagName.status);
                },
                options: this._tags.tagName
            }
        };
    }

    toggleVisibility (id, layer) {
        return this._instance.toggleVisibility(id, layer);
    }

    highlight (marker, event) {
        return this._instance.highlight(marker, event);
    }

    select(marker, type) {
        this._instance.select(marker, type);
    }

    unselect(marker, type) {
        this._instance.unselect(marker, type);
    }

    view (values) {
        return LayerInfo(this.options.name).create(values);
    }

    show (options = {}, features = this.getLayer().getCurrentFeatures()) {
        if ($('#points-collapse').length === 0 || options.refresh) {
            if (options.empty) {
                this.view(null);
            } else {
                this.view(features);
            }
        }

        if (options.show) {
            infoBoard.open();
            $('#points-tab-link').trigger('click');
            if (options.id) {
                const title = $(`#${this.options.name.toLocaleLowerCase()}-title-${options.id}`);
                return setTimeout(() => {
                    if (title[0] && !title[0].isOpen) {
                        title.trigger('select');
                    }

                    if (options.tab === 'summary') {
                        return $(`#button-${this.options.name.toLocaleLowerCase()}-summary-${options.id}`).trigger('click');
                    }
                }, 100);
            }
        }
    }

    resizeIcon (value) {
        const { symbology } = this.getLayer().options;
        switch (value) {
        case 'large':
            symbology.style.icon = {
                iconUrl: `${environment.get('IMAGES_HOST')}/pin_ponto_de_interesse.png`,
                iconSize: [50, 64], // size of the icon
                iconAnchor: [25, 60], // point of the icon which will correspond to marker's location
                labelAnchor: [25, -32]
            };
            break;

        case 'medium':
            symbology.style.icon = {
                iconUrl: `${environment.get('IMAGES_HOST')}/pin_ponto_de_interesse_sm.png`,
                iconSize: [38, 48], // size of the icon
                iconAnchor: [19, 48], // point of the icon which will correspond to marker's location
                labelAnchor: [19, -24]
            };
            break;

        case 'small':
            symbology.style.icon = {
                iconUrl: `${environment.get('IMAGES_HOST')}/pin_ponto_de_interesse_xs.png`,
                iconSize: [28, 28], // size of the icon
                iconAnchor: [14, 14], // point of the icon which will correspond to marker's location
                labelAnchor: [14, 0]
            };
            break;
        }

        this.getLayer().setOptions({ symbology });
        if (this.check() && this.getLayer().visible()) {
            return this.getLayer().reload();
        }
    }

    _setLabel() {
        this.getLayer().setOptions({ tag: this._getLayerTag() });
    }

    _toggleLabel() {
        api.general.log.action(environment._getContextEnum(this.options.name), 'Show Label', '');
        this._setLabel();
        if (this.getLayer().visible()) {
            this.getLayer().reload();
        }
    }

    _getLayerTag() {
        const name = this._getTagPropertyValue('name');

        const result = [];
        const controls = this.getControls();

        if (controls.checkbox) {
            const { checkbox } = controls;
            if (checkbox.tagName && checkbox.tagName.status) {
                result.push(name);
            }
        }

        if (result.length > 0) {
            return result;
        } else {
            return null;
        }
    }

    _getTagPropertyValue(property) {
        return _.assign({}, this._tags.tagName);
    }
}

export default PointOfInterestControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/PointOfInterestControl.js